// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2-Ois","left":"StickyBox_left__2NFWv","right":"StickyBox_right__2nmyU"};